import type { Routes } from "@angular/router";
import { AnnouncementsList } from "./announcements-list/announcements-list";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { LayoutService } from "../../../services/layout.service";

export const announcementsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => AnnouncementsList,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Comunicados`;
    }
  }
]
